import { render } from "./PrintProofPage.vue?vue&type=template&id=69885c58&scoped=true"
import script from "./PrintProofPage.vue?vue&type=script&lang=js"
export * from "./PrintProofPage.vue?vue&type=script&lang=js"

import "./PrintProofPage.vue?vue&type=style&index=0&id=69885c58&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69885c58"]])

export default __exports__